var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _ellipse, _ellipse2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnim2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 361,
    viewBox: "0 0 400 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M332.195 307.634C325.266 314.895 318.708 319.578 313.528 323.277C252.632 366.765 180.576 354.089 165.263 350.992C142.649 346.421 98.9377 337.584 67.3349 300.595C19.5229 244.633 26.9671 156.468 64.0539 98.2678C70.8377 87.6226 106.671 28.536 179.503 19.0606C223.58 13.3265 274.96 24.8915 312.167 55.9173C390.268 121.045 384.708 252.61 332.195 307.634Z",
    fill: "#DBE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.853 218.062C277.853 218.062 276.903 178.303 295.302 167.661C313.702 157.02 348.686 150.367 349.998 93.2757C350.766 59.8525 351.597 45.2391 352.154 38.8661C352.371 36.3805 350.152 34.3743 347.689 34.8354C330.263 38.1022 273.654 51.5507 261.785 90.0077C247.713 135.599 277.853 218.062 277.853 218.062Z",
    fill: "#91B3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M334.212 50.7203C315.084 67.6992 292.964 97.7502 281.176 127.8C279.663 132.753 275.236 143.284 273.314 161.997C271.596 177.604 272.45 194.095 274.532 205.012C274.664 205.702 275.333 206.155 276.026 206.025C277.218 205.799 277.059 204.524 277.048 204.563C274.67 185.912 275.657 162.697 281.105 141.751C288.065 116.031 303.59 91.0952 319.647 69.947L321.3 67.8648C333.74 51.9637 336.359 51.846 335.196 50.7387C334.921 50.4763 334.491 50.4738 334.212 50.7203Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.296 302.253C244.554 303.591 273.251 267.675 282.241 211.264C286.477 184.682 286.532 151.378 301.746 138.542C314.408 127.86 357.495 134.605 371.594 137.168C373.356 137.488 373.948 139.702 372.577 140.849C365.817 146.499 351.353 159.83 347.586 173.264C342.619 190.971 325.704 202.233 310.562 205.282C295.419 208.33 286.996 211.288 279.619 235.389C272.242 259.49 255.085 298.451 247.296 302.253Z",
    fill: "#BDD0FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M351.765 144.649C333.778 145.398 314.47 153.565 304.672 168.884L303.747 170.345C301.61 173.773 289.505 198.139 282.783 218.336C282.699 218.587 282.836 218.859 283.09 218.943C283.52 219.084 283.734 218.614 283.694 218.656C288.378 207.245 295.105 192.779 300.463 181.961C306.21 170.157 310.231 162.161 323.337 154.504C337.925 146.258 351.862 145.409 351.82 145.418C352.033 145.396 352.187 145.207 352.166 144.995C352.145 144.791 351.967 144.642 351.765 144.649Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.597 306.978C257.969 307.831 268.761 289.345 269.589 273.058C270.417 256.771 274.108 228.972 288.221 212.343C302.333 195.713 317.787 194.196 337.259 209.314C353.486 221.911 363.608 228.27 369.544 229.45C371.014 229.744 371.764 231.394 371.048 232.706C367.241 239.685 356.477 255.715 338.402 254.585C315.347 253.146 287.407 238.229 278.891 250.672C270.375 263.115 271.469 270.078 271.207 275.975C270.948 281.874 270.364 301.328 259.597 306.978Z",
    fill: "#91B3FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M330.719 229.281C323.657 222.542 312.154 215.92 302.1 217.155C289.02 219.252 280.307 227.945 275.555 240.885C273.697 246.38 272.933 249.314 271.834 256.048C271.747 256.587 272.544 256.747 272.676 256.221C273.475 253.057 274.266 249.745 275.452 246.319C282.345 224.216 297.062 221.238 297.635 220.786C298.748 220.895 305.492 215.87 321.497 224.441C324.486 226.06 327.395 227.908 330.126 229.947L330.141 229.958C330.338 230.105 330.619 230.066 330.767 229.869C330.904 229.687 330.879 229.435 330.719 229.281Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5658 288.111L66.0943 302.214C68.9514 306.937 74.5044 309.337 79.9231 308.189L92.7663 305.468C96.2395 304.733 99.8323 305.769 102.429 308.178C108.964 314.242 116.113 319.466 123.705 323.811C126.788 325.576 128.844 328.69 129.158 332.216L130.319 345.246C130.808 350.739 134.744 355.317 140.121 356.647L156.172 360.617C161.548 361.948 167.18 359.736 170.196 355.11L177.352 344.136C179.288 341.168 182.57 339.372 186.125 339.25C194.877 338.948 203.651 337.663 212.278 335.35C215.707 334.43 219.367 335.189 222.091 337.458L232.16 345.847C236.408 349.386 242.444 349.853 247.191 347.009L261.361 338.521C266.107 335.678 268.519 330.151 267.365 324.758L264.631 311.975C263.892 308.518 264.933 304.942 267.354 302.357C273.447 295.853 278.696 288.738 283.061 281.182C284.834 278.113 287.963 276.067 291.507 275.755L304.599 274.599C310.117 274.113 314.718 270.195 316.053 264.843L320.043 248.869C321.38 243.517 319.157 237.912 314.511 234.91L303.485 227.788C300.502 225.861 298.698 222.595 298.576 219.057C298.273 210.345 296.982 201.613 294.658 193.027C293.734 189.614 294.497 185.97 296.776 183.261L305.205 173.24C308.761 169.011 309.23 163.004 306.373 158.28L297.843 144.176C294.986 139.452 289.433 137.052 284.016 138.2L271.172 140.921C267.699 141.657 264.106 140.621 261.509 138.211C254.974 132.147 247.826 126.923 240.234 122.579C237.151 120.814 235.095 117.699 234.781 114.174L233.62 101.144C233.131 95.6511 229.194 91.0734 223.818 89.7429L207.767 85.7722C202.39 84.4417 196.759 86.6539 193.742 91.2794L186.587 102.253C184.651 105.222 181.369 107.017 177.814 107.139C169.061 107.44 160.288 108.726 151.661 111.038C148.232 111.958 144.57 111.199 141.847 108.93L131.779 100.541C127.531 97.0024 121.495 96.5352 116.747 99.3789L102.576 107.867C97.8301 110.711 95.4177 116.238 96.5722 121.631L99.3062 134.413C100.045 137.87 99.0043 141.446 96.5833 144.031C90.4906 150.535 85.242 157.65 80.8767 165.206C79.1038 168.274 75.9743 170.321 72.4321 170.634L59.34 171.789C53.8215 172.276 49.2209 176.194 47.8841 181.545L43.8947 197.52C42.5579 202.87 44.7805 208.475 49.4279 211.477L60.4538 218.599C63.4379 220.526 65.2404 223.793 65.3636 227.33C65.6667 236.042 66.9579 244.774 69.2816 253.36C70.2057 256.773 69.443 260.418 67.1637 263.128L58.735 273.149C55.178 277.378 54.7098 283.387 57.5658 288.111ZM94.9237 264.071C72.2423 216.224 92.8267 159.138 140.9 136.562C188.973 113.988 246.331 134.475 269.013 182.321C291.694 230.168 271.11 287.256 223.036 309.83C174.963 332.405 117.605 311.917 94.9237 264.071Z",
    fill: "url(#paint0_linear_467_2537)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M236.323 198.089C226.061 195.895 191.06 189.456 154.411 194.678C142.135 196.427 131.27 203.525 124.645 213.958C112.709 232.755 95.8241 266.264 99.3947 301.213L118.13 305.824C118.13 305.824 131.078 264.36 145.649 247.484C145.649 247.484 162.907 286.636 162.035 308.137C162.01 308.745 161.971 309.338 161.917 309.916C159.937 330.951 244.761 313.841 244.761 313.841L239.477 201.797C239.392 199.989 238.1 198.468 236.323 198.089Z",
    fill: "#2D4993"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M207.139 158.741L209.606 187.851C209.835 190.558 208.433 193.092 206.095 194.176C200.712 196.674 190.377 200.257 179.322 197.626C177.299 197.146 175.981 195.041 176.315 192.894L183.484 146.755L207.139 158.741Z",
    fill: "#FFBE9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.225 123.462C174.225 123.462 168.657 144.97 169.761 155.619C170.865 166.268 169.679 173.481 182.283 173.657C194.887 173.832 204.241 166.11 208.149 154.706C208.149 154.706 214.317 137.11 211.285 130.789C208.251 124.467 174.225 123.462 174.225 123.462Z",
    fill: "#FFBE9D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.744 147.813L201.194 148.059C201.194 148.059 205.488 134.005 199.509 132.606C193.529 131.208 170.575 130.231 164.518 123.142C158.679 116.309 161.233 105.876 166.963 102.159C167.326 101.923 167.816 102.034 168.076 102.377L168.741 103.259C169.197 103.862 170.159 103.607 170.253 102.858C170.342 102.147 171.237 101.852 171.709 102.393C173.555 104.507 178.143 107.693 189.12 107.957C204.696 108.329 215.677 112.833 217.593 123.202C217.715 123.859 218.481 124.109 218.991 123.676C219.999 122.821 221.737 122.219 224.446 123.838C229.159 126.655 228.906 135.944 220.99 144.811C220.614 145.233 220.725 145.905 221.242 146.133C223.065 146.94 225.934 149.094 220.102 153.502C214.135 158.009 210.214 158.245 208.697 158.106C208.29 158.068 207.969 157.755 207.929 157.35L207.021 148.036C206.974 147.554 206.528 147.212 206.049 147.288L202.744 147.813Z",
    fill: "#314148"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M202.673 149.803C202.673 149.803 203.966 136.423 210.331 139.105C216.696 141.787 209.639 153.976 205.064 155.196L202.673 149.803Z",
    fill: "url(#paint1_linear_467_2537)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.08 280.408C240.909 267.552 227.532 248.655 221.999 241.484C220.416 239.432 219.531 236.925 219.509 234.338C219.348 216.132 225.54 206.621 237.847 198.769C237.847 198.769 284.002 248.38 272.629 288.218C271.402 292.518 269.5 296.211 267.088 299.385C265.296 284.375 247.864 281.101 239.08 280.408Z",
    fill: "#2D4993"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M238.245 275.436L239.947 275.242C238.504 262.635 227.39 247.071 222.678 240.965L221.319 242.004C225.944 247.998 236.851 263.253 238.245 275.436Z",
    fill: "#0A1D4F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.728 282.189C238.885 281.611 238.993 281.014 239.079 280.408C247.864 281.101 265.297 284.375 267.088 299.386C247.156 325.624 192.212 316.158 192.212 316.158V305.948C192.212 305.949 234.409 298.146 238.728 282.189Z",
    fill: "#FFBE9D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M197.494 313.34C197.494 313.34 189.382 294.287 175.088 301.045C160.793 307.803 161.917 312.225 161.917 312.225L197.494 313.34Z",
    fill: "#FFBE9D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M199.316 317.293C199.203 318.735 197.968 319.832 196.517 319.781L122.444 317.21C121.294 317.169 120.293 316.41 119.949 315.317L117.799 308.469C117.271 306.787 118.477 305.06 120.245 304.967L147.257 303.538C147.502 303.525 147.749 303.546 147.988 303.598L197.198 314.446C198.519 314.736 199.422 315.951 199.316 317.293Z",
    fill: "#6886D7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M149.665 314.603L147.627 305.149L119.88 306.468L121.706 314.311L149.665 314.603Z",
    fill: "#6886D7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M163.889 212.63C165.46 225.4 172.524 277.287 174.545 292.112C174.83 294.196 173.166 296.031 171.053 295.971L51.2169 292.558C49.6484 292.514 48.3116 291.414 47.9716 289.89L29.3302 206.334C28.8374 204.126 30.6042 202.061 32.8737 202.192L160.689 209.643C162.343 209.738 163.688 210.994 163.889 212.63Z",
    fill: "#6886D7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.72 265.258L133.431 315.29L92.2488 316.158L88.8199 265.557C88.6585 263.183 90.6372 261.211 93.0237 261.369L112.256 262.64C113.832 262.745 115.195 263.774 115.72 265.258Z",
    fill: "#6886D7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.127 316.002C150.58 317.379 149.55 318.794 148.094 318.794H83.6007C82.4191 318.794 81.4618 317.841 81.4618 316.665V313.912C81.4618 312.701 82.4758 311.733 83.6919 311.786L148.186 314.539C149.076 314.577 149.848 315.161 150.127 316.002Z",
    fill: "#6886D7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M182.299 163.108C196.739 166.875 208.02 153.356 208.132 153.218L207.25 152.502C207.143 152.633 196.314 165.593 182.588 162.012L182.299 163.108Z",
    fill: "url(#paint2_linear_467_2537)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M178.651 161.188C178.349 162.01 178.773 162.921 179.6 163.221L182.367 164.229C183.193 164.53 184.108 164.108 184.41 163.285L184.58 162.824C184.882 162.002 184.458 161.091 183.631 160.791L180.864 159.783C180.038 159.482 179.123 159.904 178.821 160.727L178.651 161.188Z",
    fill: "url(#paint3_linear_467_2537)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.066 163.468L183.312 165.248L183.4 165.28L184.066 163.468Z",
    fill: "url(#paint4_linear_467_2537)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M184.809 161.22L183.069 165.785L183.11 165.799L184.31 163.557L185.127 161.335L184.809 161.22Z",
    fill: "url(#paint5_linear_467_2537)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M184.77 161.205L183.03 165.77L183.07 165.785L184.809 161.22L184.77 161.205Z",
    fill: "url(#paint6_linear_467_2537)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M184.729 161.19L182.99 165.756L183.03 165.771L184.769 161.205L184.729 161.19Z",
    fill: "url(#paint7_linear_467_2537)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184.69 161.176L182.95 165.741L182.991 165.756L184.729 161.19L184.69 161.176Z",
    fill: "url(#paint8_linear_467_2537)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M184.65 161.161L182.91 165.726L182.95 165.741L184.69 161.176L184.65 161.161Z",
    fill: "url(#paint9_linear_467_2537)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M184.61 161.146L182.87 165.712L182.911 165.726L184.65 161.161L184.61 161.146Z",
    fill: "url(#paint10_linear_467_2537)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.57 161.133L182.83 165.697L182.87 165.712L184.609 161.146L184.57 161.133Z",
    fill: "url(#paint11_linear_467_2537)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M184.531 161.118L182.791 165.683L182.83 165.697L184.57 161.133L184.531 161.118Z",
    fill: "url(#paint12_linear_467_2537)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M184.49 161.103L182.75 165.669L182.791 165.683L184.53 161.118L184.49 161.103Z",
    fill: "url(#paint13_linear_467_2537)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M184.451 161.089L182.711 165.654L182.75 165.669L184.49 161.103L184.451 161.089Z",
    fill: "url(#paint14_linear_467_2537)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M184.411 161.074L182.672 165.639L182.711 165.654L184.451 161.088L184.411 161.074Z",
    fill: "url(#paint15_linear_467_2537)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M184.37 161.059L182.631 165.624L182.671 165.639L184.411 161.074L184.37 161.059Z",
    fill: "url(#paint16_linear_467_2537)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M184.331 161.046L182.592 165.61L182.631 165.625L184.371 161.059L184.331 161.046Z",
    fill: "url(#paint17_linear_467_2537)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M184.29 161.031L182.552 165.596L182.591 165.61L184.331 161.046L184.29 161.031Z",
    fill: "url(#paint18_linear_467_2537)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M184.251 161.016L182.511 165.582L182.552 165.596L184.29 161.031L184.251 161.016Z",
    fill: "url(#paint19_linear_467_2537)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M184.211 161.001L182.472 165.567L182.511 165.582L184.251 161.016L184.211 161.001Z",
    fill: "url(#paint20_linear_467_2537)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M184.171 160.987L182.432 165.552L182.472 165.567L184.212 161.002L184.171 160.987Z",
    fill: "url(#paint21_linear_467_2537)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M184.131 160.972L182.392 165.538L182.432 165.552L184.171 160.987L184.131 160.972Z",
    fill: "url(#paint22_linear_467_2537)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M184.092 160.957L182.352 165.523L182.392 165.537L184.131 160.972L184.092 160.957Z",
    fill: "url(#paint23_linear_467_2537)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M184.051 160.944L182.312 165.508L182.352 165.523L184.092 160.957L184.051 160.944Z",
    fill: "url(#paint24_linear_467_2537)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M184.012 160.929L182.272 165.495L182.312 165.508L184.051 160.944L184.012 160.929Z",
    fill: "url(#paint25_linear_467_2537)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M183.973 160.915L182.233 165.48L182.272 165.495L184.012 160.929L183.973 160.915Z",
    fill: "url(#paint26_linear_467_2537)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M183.932 160.9L182.192 165.465L182.233 165.48L183.972 160.914L183.932 160.9Z",
    fill: "url(#paint27_linear_467_2537)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M183.893 160.885L182.153 165.45L182.192 165.465L183.932 160.9L183.893 160.885Z",
    fill: "url(#paint28_linear_467_2537)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M183.853 160.87L182.113 165.436L182.153 165.45L183.892 160.885L183.853 160.87Z",
    fill: "url(#paint29_linear_467_2537)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M183.812 160.857L182.073 165.421L182.113 165.436L183.853 160.87L183.812 160.857Z",
    fill: "url(#paint30_linear_467_2537)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M183.773 160.842L182.033 165.407L182.073 165.421L183.812 160.857L183.773 160.842Z",
    fill: "url(#paint31_linear_467_2537)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M183.733 160.827L181.994 165.393L182.033 165.408L183.773 160.842L183.733 160.827Z",
    fill: "url(#paint32_linear_467_2537)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M183.693 160.813L181.953 165.378L181.994 165.393L183.733 160.827L183.693 160.813Z",
    fill: "url(#paint33_linear_467_2537)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M183.653 160.798L181.914 165.363L181.953 165.378L183.693 160.813L183.653 160.798Z",
    fill: "url(#paint34_linear_467_2537)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M183.613 160.783L181.874 165.349L181.914 165.363L183.654 160.798L183.613 160.783Z",
    fill: "url(#paint35_linear_467_2537)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M183.573 160.77L181.834 165.334L181.874 165.349L183.613 160.783L183.573 160.77Z",
    fill: "url(#paint36_linear_467_2537)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M183.534 160.755L181.794 165.32L181.834 165.334L183.573 160.77L183.534 160.755Z",
    fill: "url(#paint37_linear_467_2537)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.493 160.74L181.754 165.306L181.794 165.32L183.534 160.755L183.493 160.74Z",
    fill: "url(#paint38_linear_467_2537)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M183.454 160.726L181.714 165.291L181.754 165.306L183.493 160.74L183.454 160.726Z",
    fill: "url(#paint39_linear_467_2537)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M183.414 160.711L181.675 165.276L181.714 165.291L183.454 160.725L183.414 160.711Z",
    fill: "url(#paint40_linear_467_2537)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M183.373 160.696L181.634 165.261L181.674 165.276L183.414 160.711L183.373 160.696Z",
    fill: "url(#paint41_linear_467_2537)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M183.334 160.682L181.594 165.247L181.634 165.262L183.374 160.696L183.334 160.682Z",
    fill: "url(#paint42_linear_467_2537)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M183.295 160.668L181.555 165.232L181.595 165.247L183.334 160.681L183.295 160.668Z",
    fill: "url(#paint43_linear_467_2537)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M183.254 160.653L181.514 165.219L181.555 165.232L183.295 160.668L183.254 160.653Z",
    fill: "url(#paint44_linear_467_2537)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M183.215 160.638L181.475 165.204L181.515 165.219L183.254 160.653L183.215 160.638Z",
    fill: "url(#paint45_linear_467_2537)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M183.175 160.624L181.436 165.189L181.475 165.204L183.215 160.638L183.175 160.624Z",
    fill: "url(#paint46_linear_467_2537)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M183.135 160.609L181.395 165.175L181.436 165.189L183.175 160.624L183.135 160.609Z",
    fill: "url(#paint47_linear_467_2537)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M183.095 160.594L181.356 165.16L181.395 165.174L183.135 160.609L183.095 160.594Z",
    fill: "url(#paint48_linear_467_2537)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M183.055 160.581L181.316 165.145L181.355 165.16L183.095 160.594L183.055 160.581Z",
    fill: "url(#paint49_linear_467_2537)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M183.015 160.566L181.276 165.132L181.316 165.145L183.055 160.581L183.015 160.566Z",
    fill: "url(#paint50_linear_467_2537)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M182.976 160.552L181.236 165.117L181.275 165.132L183.015 160.566L182.976 160.552Z",
    fill: "url(#paint51_linear_467_2537)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M182.935 160.537L181.197 165.102L181.236 165.117L182.976 160.551L182.935 160.537Z",
    fill: "url(#paint52_linear_467_2537)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M182.896 160.522L181.156 165.087L181.197 165.102L182.935 160.537L182.896 160.522Z",
    fill: "url(#paint53_linear_467_2537)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M182.856 160.507L181.117 165.073L181.156 165.087L182.896 160.522L182.856 160.507Z",
    fill: "url(#paint54_linear_467_2537)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M182.815 160.493L181.076 165.058L181.116 165.073L182.856 160.507L182.815 160.493Z",
    fill: "url(#paint55_linear_467_2537)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M182.776 160.479L181.036 165.044L181.076 165.058L182.816 160.492L182.776 160.479Z",
    fill: "url(#paint56_linear_467_2537)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M182.737 160.464L180.997 165.03L181.037 165.044L182.776 160.479L182.737 160.464Z",
    fill: "url(#paint57_linear_467_2537)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M182.696 160.45L180.956 165.015L180.997 165.03L182.737 160.464L182.696 160.45Z",
    fill: "url(#paint58_linear_467_2537)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M182.657 160.435L180.917 165L180.957 165.015L182.696 160.45L182.657 160.435Z",
    fill: "url(#paint59_linear_467_2537)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M182.617 160.42L180.877 164.986L180.917 165L182.657 160.435L182.617 160.42Z",
    fill: "url(#paint60_linear_467_2537)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M182.577 160.406L180.837 164.971L180.878 164.986L182.617 160.42L182.577 160.406Z",
    fill: "url(#paint61_linear_467_2537)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M182.537 160.392L180.797 164.956L180.837 164.971L182.576 160.406L182.537 160.392Z",
    fill: "url(#paint62_linear_467_2537)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M182.497 160.377L180.758 164.943L180.797 164.956L182.537 160.392L182.497 160.377Z",
    fill: "url(#paint63_linear_467_2537)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M182.457 160.363L180.717 164.928L180.758 164.943L182.496 160.377L182.457 160.363Z",
    fill: "url(#paint64_linear_467_2537)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M182.418 160.348L180.678 164.913L180.717 164.928L182.457 160.363L182.418 160.348Z",
    fill: "url(#paint65_linear_467_2537)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M182.377 160.333L180.639 164.898L180.678 164.913L182.418 160.348L182.377 160.333Z",
    fill: "url(#paint66_linear_467_2537)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M182.337 160.318L180.598 164.884L180.638 164.898L182.377 160.333L182.337 160.318Z",
    fill: "url(#paint67_linear_467_2537)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M182.298 160.305L180.559 164.869L180.598 164.884L182.338 160.318L182.298 160.305Z",
    fill: "url(#paint68_linear_467_2537)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M182.258 160.29L180.518 164.855L180.558 164.869L182.298 160.305L182.258 160.29Z",
    fill: "url(#paint69_linear_467_2537)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M182.218 160.276L180.478 164.841L180.518 164.856L182.258 160.29L182.218 160.276Z",
    fill: "url(#paint70_linear_467_2537)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M182.179 160.261L180.439 164.826L180.478 164.841L182.218 160.275L182.179 160.261Z",
    fill: "url(#paint71_linear_467_2537)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M182.138 160.246L180.398 164.811L180.439 164.826L182.179 160.261L182.138 160.246Z",
    fill: "url(#paint72_linear_467_2537)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M182.098 160.231L180.359 164.797L180.398 164.811L182.138 160.246L182.098 160.231Z",
    fill: "url(#paint73_linear_467_2537)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M182.059 160.217L180.319 164.782L180.359 164.797L182.098 160.232L182.059 160.217Z",
    fill: "url(#paint74_linear_467_2537)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M182.018 160.203L180.279 164.767L180.319 164.782L182.059 160.217L182.018 160.203Z",
    fill: "url(#paint75_linear_467_2537)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M181.979 160.188L180.239 164.754L180.279 164.767L182.018 160.203L181.979 160.188Z",
    fill: "url(#paint76_linear_467_2537)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M181.94 160.174L180.2 164.739L180.239 164.754L181.979 160.189L181.94 160.174Z",
    fill: "url(#paint77_linear_467_2537)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M181.899 160.159L180.159 164.724L180.2 164.739L181.94 160.174L181.899 160.159Z",
    fill: "url(#paint78_linear_467_2537)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M181.86 160.144L180.12 164.71L180.159 164.724L181.899 160.159L181.86 160.144Z",
    fill: "url(#paint79_linear_467_2537)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M181.819 160.13L180.08 164.695L180.12 164.71L181.859 160.144L181.819 160.13Z",
    fill: "url(#paint80_linear_467_2537)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M181.779 160.116L180.04 164.68L180.08 164.695L181.819 160.13L181.779 160.116Z",
    fill: "url(#paint81_linear_467_2537)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M181.74 160.101L180 164.667L180.04 164.68L181.779 160.116L181.74 160.101Z",
    fill: "url(#paint82_linear_467_2537)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M181.7 160.087L179.96 164.652L180 164.667L181.74 160.101L181.7 160.087Z",
    fill: "url(#paint83_linear_467_2537)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M181.66 160.072L179.92 164.637L179.96 164.652L181.699 160.087L181.66 160.072Z",
    fill: "url(#paint84_linear_467_2537)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M181.62 160.057L179.881 164.623L179.92 164.637L181.66 160.072L181.62 160.057Z",
    fill: "url(#paint85_linear_467_2537)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M181.58 160.042L179.84 164.608L179.881 164.623L181.62 160.057L181.58 160.042Z",
    fill: "url(#paint86_linear_467_2537)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M181.54 160.028L179.801 164.593L179.84 164.608L181.58 160.043L181.54 160.028Z",
    fill: "url(#paint87_linear_467_2537)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M181.501 160.014L179.761 164.58L179.801 164.593L181.54 160.028L181.501 160.014Z",
    fill: "url(#paint88_linear_467_2537)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M181.46 160L179.721 164.565L179.761 164.58L181.501 160.014L181.46 160Z",
    fill: "url(#paint89_linear_467_2537)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M181.421 159.985L179.681 164.55L179.721 164.565L181.461 160L181.421 159.985Z",
    fill: "url(#paint90_linear_467_2537)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M181.38 159.97L179.642 164.536L179.681 164.55L181.421 159.985L181.38 159.97Z",
    fill: "url(#paint91_linear_467_2537)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M181.341 159.955L179.601 164.521L179.642 164.535L181.38 159.97L181.341 159.955Z",
    fill: "url(#paint92_linear_467_2537)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M181.301 159.941L179.562 164.506L179.601 164.521L181.341 159.956L181.301 159.941Z",
    fill: "url(#paint93_linear_467_2537)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M181.261 159.927L179.522 164.491L179.562 164.506L181.301 159.941L181.261 159.927Z",
    fill: "url(#paint94_linear_467_2537)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.221 159.913L179.482 164.478L179.522 164.491L181.261 159.927L181.221 159.913Z",
    fill: "url(#paint95_linear_467_2537)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M181.182 159.898L179.442 164.463L179.482 164.478L181.221 159.912L181.182 159.898Z",
    fill: "url(#paint96_linear_467_2537)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M181.141 159.883L179.403 164.449L179.442 164.463L181.182 159.898L181.141 159.883Z",
    fill: "url(#paint97_linear_467_2537)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M181.102 159.868L179.362 164.434L179.403 164.449L181.141 159.883L181.102 159.868Z",
    fill: "url(#paint98_linear_467_2537)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M181.062 159.854L179.323 164.419L179.362 164.434L181.102 159.868L181.062 159.854Z",
    fill: "url(#paint99_linear_467_2537)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M181.022 159.84L179.282 164.405L179.323 164.419L181.062 159.854L181.022 159.84Z",
    fill: "url(#paint100_linear_467_2537)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M180.982 159.825L179.243 164.391L179.282 164.404L181.022 159.84L180.982 159.825Z",
    fill: "url(#paint101_linear_467_2537)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M180.943 159.811L179.203 164.376L179.242 164.391L180.982 159.826L180.943 159.811Z",
    fill: "url(#paint102_linear_467_2537)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M180.902 159.796L179.163 164.362L179.203 164.376L180.943 159.811L180.902 159.796Z",
    fill: "url(#paint103_linear_467_2537)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M180.863 159.781L179.123 164.347L179.162 164.361L180.902 159.796L180.863 159.781Z",
    fill: "url(#paint104_linear_467_2537)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M180.822 159.767L179.084 164.332L179.123 164.347L180.863 159.781L180.822 159.767Z",
    fill: "url(#paint105_linear_467_2537)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M180.783 159.752L179.043 164.317L179.083 164.332L180.822 159.767L180.783 159.752Z",
    fill: "url(#paint106_linear_467_2537)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M180.743 159.739L179.004 164.303L179.043 164.317L180.783 159.752L180.743 159.739Z",
    fill: "url(#paint107_linear_467_2537)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M180.702 159.724L178.963 164.289L179.003 164.303L180.743 159.738L180.702 159.724Z",
    fill: "url(#paint108_linear_467_2537)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M180.663 159.709L178.923 164.274L178.963 164.289L180.703 159.724L180.663 159.709Z",
    fill: "url(#paint109_linear_467_2537)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M180.624 159.694L178.884 164.26L178.924 164.274L180.663 159.709L180.624 159.694Z",
    fill: "url(#paint110_linear_467_2537)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M180.583 159.68L178.843 164.245L178.884 164.26L180.624 159.694L180.583 159.68Z",
    fill: "url(#paint111_linear_467_2537)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M180.544 159.665L178.804 164.23L178.844 164.245L180.583 159.68L180.544 159.665Z",
    fill: "url(#paint112_linear_467_2537)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M180.504 159.651L178.764 164.216L178.804 164.23L180.544 159.665L180.504 159.651Z",
    fill: "url(#paint113_linear_467_2537)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M180.463 159.637L178.724 164.202L178.764 164.216L180.504 159.651L180.463 159.637Z",
    fill: "url(#paint114_linear_467_2537)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M180.424 159.622L178.684 164.187L178.724 164.202L180.463 159.637L180.424 159.622Z",
    fill: "url(#paint115_linear_467_2537)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M180.385 159.607L178.645 164.173L178.684 164.187L180.424 159.622L180.385 159.607Z",
    fill: "url(#paint116_linear_467_2537)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M180.344 159.593L178.604 164.158L178.645 164.173L180.385 159.607L180.344 159.593Z",
    fill: "url(#paint117_linear_467_2537)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M180.305 159.578L178.565 164.143L178.604 164.158L180.344 159.593L180.305 159.578Z",
    fill: "url(#paint118_linear_467_2537)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M180.265 159.563L178.526 164.128L178.565 164.143L180.305 159.578L180.265 159.563Z",
    fill: "url(#paint119_linear_467_2537)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M180.225 159.55L178.485 164.115L178.526 164.128L180.265 159.563L180.225 159.55Z",
    fill: "url(#paint120_linear_467_2537)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M180.185 159.535L178.446 164.1L178.485 164.115L180.225 159.55L180.185 159.535Z",
    fill: "url(#paint121_linear_467_2537)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M180.144 159.52L178.406 164.086L178.445 164.1L180.185 159.535L180.144 159.52Z",
    fill: "url(#paint122_linear_467_2537)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M180.105 159.505L178.365 164.071L178.406 164.085L180.145 159.52L180.105 159.505Z",
    fill: "url(#paint123_linear_467_2537)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M180.065 159.492L178.326 164.057L178.365 164.072L180.105 159.506L180.065 159.492Z",
    fill: "url(#paint124_linear_467_2537)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M180.025 159.477L178.285 164.042L178.326 164.057L180.066 159.492L180.025 159.477Z",
    fill: "url(#paint125_linear_467_2537)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M179.985 159.463L178.246 164.028L178.285 164.042L180.025 159.477L179.985 159.463Z",
    fill: "url(#paint126_linear_467_2537)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M179.946 159.449L178.206 164.014L178.246 164.028L179.986 159.463L179.946 159.449Z",
    fill: "url(#paint127_linear_467_2537)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M179.905 159.434L178.166 163.999L178.206 164.014L179.946 159.449L179.905 159.434Z",
    fill: "url(#paint128_linear_467_2537)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M179.866 159.419L178.126 163.985L178.166 163.999L179.905 159.434L179.866 159.419Z",
    fill: "url(#paint129_linear_467_2537)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M179.827 159.405L178.087 163.97L178.126 163.985L179.866 159.419L179.827 159.405Z",
    fill: "url(#paint130_linear_467_2537)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M179.786 159.39L178.046 163.955L178.087 163.97L179.827 159.404L179.786 159.39Z",
    fill: "#4765B5"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M179.747 159.376L178.007 163.94L178.046 163.955L179.786 159.39L179.747 159.376Z",
    fill: "#4765B5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M179.706 159.361L177.967 163.927L178.007 163.94L179.746 159.376L179.706 159.361Z",
    fill: "#4765B5"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M179.667 159.347L177.927 163.912L177.968 163.927L179.706 159.361L179.667 159.347Z",
    fill: "#4765B5"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M179.627 159.332L177.887 163.897L177.927 163.912L179.666 159.347L179.627 159.332Z",
    fill: "#4765B5"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M179.586 159.317L177.848 163.883L177.887 163.897L179.627 159.332L179.586 159.317Z",
    fill: "#4765B5"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M179.547 159.303L177.807 163.869L177.848 163.883L179.586 159.318L179.547 159.303Z",
    fill: "#4765B5"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M179.508 159.288L177.768 163.854L177.807 163.868L179.547 159.303L179.508 159.288Z",
    fill: "#4765B5"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M179.467 159.275L177.728 163.84L177.768 163.854L179.508 159.288L179.467 159.275Z",
    fill: "#4765B5"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M179.427 159.26L177.688 163.825L177.728 163.84L179.467 159.275L179.427 159.26Z",
    fill: "#4765B5"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M179.388 159.245L177.648 163.811L177.688 163.825L179.427 159.26L179.388 159.245Z",
    fill: "#4765B5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M179.347 159.23L177.608 163.796L177.648 163.811L179.388 159.245L179.347 159.23Z",
    fill: "#4765B5"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M179.308 159.216L177.568 163.781L177.608 163.796L179.347 159.23L179.308 159.216Z",
    fill: "#4765B5"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M179.268 159.201L177.529 163.766L177.568 163.781L179.308 159.216L179.268 159.201Z",
    fill: "#4765B5"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M179.228 159.187L177.488 163.751L177.529 163.766L179.268 159.201L179.228 159.187Z",
    fill: "#4765B5"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M179.188 159.173L177.449 163.738L177.488 163.751L179.228 159.187L179.188 159.173Z",
    fill: "#4765B5"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M179.149 159.158L177.409 163.723L177.449 163.738L179.188 159.172L179.149 159.158Z",
    fill: "#4765B5"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M179.108 159.143L177.368 163.708L177.409 163.723L179.149 159.158L179.108 159.143Z",
    fill: "#4765B5"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M179.069 159.128L177.329 163.694L177.369 163.708L179.108 159.143L179.069 159.128Z",
    fill: "#4765B5"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M179.028 159.114L177.29 163.679L177.329 163.694L179.069 159.128L179.028 159.114Z",
    fill: "#4765B5"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M178.989 159.099L177.249 163.664L177.29 163.679L179.028 159.113L178.989 159.099Z",
    fill: "#4765B5"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M178.949 159.085L177.21 163.651L177.249 163.664L178.989 159.099L178.949 159.085Z",
    fill: "#4765B5"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M178.909 159.07L177.169 163.636L177.21 163.65L178.949 159.085L178.909 159.07Z",
    fill: "#4765B5"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M178.869 159.055L177.13 163.621L177.169 163.636L178.909 159.07L178.869 159.055Z",
    fill: "#4765B5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M178.83 159.041L177.09 163.606L177.13 163.621L178.869 159.055L178.83 159.041Z",
    fill: "#4765B5"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M178.789 159.026L178.626 161.256L177.683 163.822L177.09 163.606L178.83 159.041L178.789 159.026Z",
    fill: "#4765B5"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M178.16 161.086L178.62 159.488L178.731 159.529L178.16 161.086Z",
    fill: "#4765B5"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M210.379 136.494C210.379 136.494 209.368 112.252 195.23 107.206C195.23 107.206 199.659 106.107 203.594 109.016C207.53 111.925 216.451 125.381 213.911 137.781C210.801 138.179 210.379 136.494 210.379 136.494Z",
    fill: "#4765B5"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M213.118 135.539C220.869 138.631 218.017 148.582 218.017 148.582C217.246 156.04 214.42 159.292 211.338 160.526C209.232 161.368 206.836 161.046 205.027 159.682C203.219 158.318 202.26 156.11 202.503 153.865C202.722 151.836 202.902 149.904 202.876 149.201C202.816 147.498 205.369 132.448 213.118 135.539Z",
    fill: "#4765B5"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M211.908 137.966C213.632 137.981 215.118 139.165 215.505 140.837C218.277 152.805 211.043 158.944 208.116 158.567C205.031 158.17 207.782 143.547 209.121 139.913C209.683 138.39 210.799 137.956 211.908 137.966Z",
    fill: "#4765B5"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M165.647 265.651L166.601 265.531L160.714 219.317C160.346 216.424 157.957 214.2 155.034 214.024L44.5809 207.385L44.5229 208.341L154.976 214.98C157.438 215.127 159.449 217.002 159.76 219.437L165.647 265.651Z",
    fill: "#91B3FA"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M168.293 278.706L167.34 278.825L168.606 288.832L169.56 288.712L168.293 278.706Z",
    fill: "#91B3FA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M127.596 159.206C127.596 159.206 19.9667 106.278 55.1647 67.3081C90.3639 28.3385 155.986 43.9146 159.31 84.9309C162.634 125.946 82.7632 116.323 127.596 159.206Z",
    fill: "#BDD0FB"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1841 77.3733C63.1841 77.9705 63.6695 78.4537 64.2695 78.4537H111.77C112.369 78.4537 112.855 77.9705 112.855 77.3733C112.855 76.7761 112.37 76.293 111.77 76.293H64.2695C63.6695 76.293 63.1841 76.7761 63.1841 77.3733Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M125.873 78.4524H139.968C140.567 78.4524 141.054 77.9693 141.054 77.3721C141.054 76.7749 140.568 76.2917 139.968 76.2917H125.873C125.275 76.2917 124.788 76.7749 124.788 77.3721C124.789 77.9705 125.275 78.4524 125.873 78.4524Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5836 86.9431C61.5836 87.5403 62.0691 88.0235 62.6691 88.0235H80.5046C81.1034 88.0235 81.5901 87.5403 81.5901 86.9431C81.5901 86.3459 81.1047 85.8628 80.5046 85.8628H62.6691C62.0691 85.864 61.5836 86.3472 61.5836 86.9431Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M105.591 86.9431C105.591 87.5403 106.076 88.0235 106.676 88.0235H138.369C138.968 88.0235 139.455 87.5403 139.455 86.9431C139.455 86.3459 138.969 85.8628 138.369 85.8628H106.676C106.076 85.864 105.591 86.3472 105.591 86.9431Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0686 97.5957H108.481C109.08 97.5957 109.567 97.1126 109.567 96.5154C109.567 95.9182 109.081 95.4351 108.481 95.4351H61.0686C60.4698 95.4351 59.9832 95.9182 59.9832 96.5154C59.9832 97.1126 60.4698 97.5957 61.0686 97.5957Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M120.354 97.5957H136.767C137.366 97.5957 137.853 97.1126 137.853 96.5154C137.853 95.9182 137.367 95.4351 136.767 95.4351H120.354C119.755 95.4351 119.268 95.9182 119.268 96.5154C119.268 97.1126 119.755 97.5957 120.354 97.5957Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7061 36.5401C67.3992 36.3325 63.7376 39.6496 63.5295 43.9473L54.1504 43.4951C54.6087 34.0284 62.6723 26.7236 72.1646 27.1812L71.7115 36.5403L71.7061 36.5401Z",
    fill: "#EC575E"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M398.5 206.49C398.5 209.925 395.708 212.715 392.258 212.715C388.808 212.715 386.016 209.925 386.016 206.49C386.016 203.055 388.808 200.264 392.258 200.264C395.708 200.264 398.5 203.055 398.5 206.49Z",
    stroke: "#3BB54A",
    strokeWidth: 3
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49334 261.149C11.6308 265.399 18.4363 265.498 22.6957 261.369L7.71151 245.976C3.45212 250.105 3.3559 256.898 7.49334 261.149Z",
    fill: "#6886D7"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.839,
    cy: 17.6447,
    rx: 4.30108,
    ry: 4.29194,
    fill: "#4725A9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 191.151,
    cy: 2.14597,
    rx: 2.15054,
    ry: 2.14597,
    fill: "#F2C94C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_467_2537",
    x1: 305.588,
    y1: 109.554,
    x2: -37.161,
    y2: 427.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_467_2537",
    x1: 204.891,
    y1: 146.392,
    x2: 173.465,
    y2: 138.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_467_2537",
    x1: 205.251,
    y1: 172.031,
    x2: 189.544,
    y2: 150.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_467_2537",
    x1: 178.554,
    y1: 162.006,
    x2: 184.677,
    y2: 162.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_467_2537",
    x1: 183.312,
    y1: 164.374,
    x2: 184.067,
    y2: 164.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_467_2537",
    x1: 183.07,
    y1: 163.509,
    x2: 185.127,
    y2: 163.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_467_2537",
    x1: 183.03,
    y1: 163.495,
    x2: 184.809,
    y2: 163.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_467_2537",
    x1: 182.99,
    y1: 163.48,
    x2: 184.769,
    y2: 163.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_467_2537",
    x1: 182.95,
    y1: 163.466,
    x2: 184.73,
    y2: 163.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_467_2537",
    x1: 182.91,
    y1: 163.451,
    x2: 184.69,
    y2: 163.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_467_2537",
    x1: 182.871,
    y1: 163.437,
    x2: 184.65,
    y2: 163.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_467_2537",
    x1: 182.831,
    y1: 163.422,
    x2: 184.61,
    y2: 163.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_467_2537",
    x1: 182.791,
    y1: 163.407,
    x2: 184.57,
    y2: 163.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_467_2537",
    x1: 182.751,
    y1: 163.393,
    x2: 184.53,
    y2: 163.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_467_2537",
    x1: 182.711,
    y1: 163.379,
    x2: 184.49,
    y2: 163.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_467_2537",
    x1: 182.671,
    y1: 163.364,
    x2: 184.451,
    y2: 163.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_467_2537",
    x1: 182.631,
    y1: 163.349,
    x2: 184.411,
    y2: 163.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_467_2537",
    x1: 182.592,
    y1: 163.335,
    x2: 184.371,
    y2: 163.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_467_2537",
    x1: 182.551,
    y1: 163.32,
    x2: 184.331,
    y2: 163.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_467_2537",
    x1: 182.512,
    y1: 163.306,
    x2: 184.291,
    y2: 163.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_467_2537",
    x1: 182.472,
    y1: 163.291,
    x2: 184.251,
    y2: 163.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_467_2537",
    x1: 182.432,
    y1: 163.277,
    x2: 184.211,
    y2: 163.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_467_2537",
    x1: 182.392,
    y1: 163.262,
    x2: 184.171,
    y2: 163.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_467_2537",
    x1: 182.352,
    y1: 163.248,
    x2: 184.131,
    y2: 163.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_467_2537",
    x1: 182.312,
    y1: 163.233,
    x2: 184.092,
    y2: 163.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_467_2537",
    x1: 182.272,
    y1: 163.219,
    x2: 184.052,
    y2: 163.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_467_2537",
    x1: 182.233,
    y1: 163.204,
    x2: 184.012,
    y2: 163.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_467_2537",
    x1: 182.193,
    y1: 163.19,
    x2: 183.972,
    y2: 163.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_467_2537",
    x1: 182.153,
    y1: 163.175,
    x2: 183.932,
    y2: 163.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_467_2537",
    x1: 182.113,
    y1: 163.16,
    x2: 183.892,
    y2: 163.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_467_2537",
    x1: 182.073,
    y1: 163.146,
    x2: 183.853,
    y2: 163.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_467_2537",
    x1: 182.033,
    y1: 163.132,
    x2: 183.813,
    y2: 163.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_467_2537",
    x1: 181.993,
    y1: 163.117,
    x2: 183.773,
    y2: 163.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_467_2537",
    x1: 181.953,
    y1: 163.103,
    x2: 183.733,
    y2: 163.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_467_2537",
    x1: 181.914,
    y1: 163.088,
    x2: 183.693,
    y2: 163.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_467_2537",
    x1: 181.874,
    y1: 163.074,
    x2: 183.653,
    y2: 163.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_467_2537",
    x1: 181.834,
    y1: 163.059,
    x2: 183.613,
    y2: 163.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_467_2537",
    x1: 181.794,
    y1: 163.044,
    x2: 183.574,
    y2: 163.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_467_2537",
    x1: 181.754,
    y1: 163.03,
    x2: 183.534,
    y2: 163.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_467_2537",
    x1: 181.714,
    y1: 163.015,
    x2: 183.494,
    y2: 163.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_467_2537",
    x1: 181.674,
    y1: 163.001,
    x2: 183.454,
    y2: 163.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_467_2537",
    x1: 181.634,
    y1: 162.986,
    x2: 183.414,
    y2: 162.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_467_2537",
    x1: 181.595,
    y1: 162.972,
    x2: 183.374,
    y2: 162.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_467_2537",
    x1: 181.555,
    y1: 162.957,
    x2: 183.334,
    y2: 162.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_467_2537",
    x1: 181.515,
    y1: 162.943,
    x2: 183.294,
    y2: 162.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_467_2537",
    x1: 181.475,
    y1: 162.928,
    x2: 183.255,
    y2: 162.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_467_2537",
    x1: 181.435,
    y1: 162.914,
    x2: 183.215,
    y2: 162.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_467_2537",
    x1: 181.395,
    y1: 162.899,
    x2: 183.175,
    y2: 162.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_467_2537",
    x1: 181.356,
    y1: 162.885,
    x2: 183.135,
    y2: 162.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_467_2537",
    x1: 181.315,
    y1: 162.87,
    x2: 183.095,
    y2: 162.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_467_2537",
    x1: 181.276,
    y1: 162.856,
    x2: 183.055,
    y2: 162.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_467_2537",
    x1: 181.236,
    y1: 162.841,
    x2: 183.015,
    y2: 162.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_467_2537",
    x1: 181.196,
    y1: 162.827,
    x2: 182.975,
    y2: 162.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_467_2537",
    x1: 181.156,
    y1: 162.812,
    x2: 182.935,
    y2: 162.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_467_2537",
    x1: 181.116,
    y1: 162.798,
    x2: 182.896,
    y2: 162.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_467_2537",
    x1: 181.076,
    y1: 162.783,
    x2: 182.856,
    y2: 162.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_467_2537",
    x1: 181.037,
    y1: 162.768,
    x2: 182.816,
    y2: 162.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_467_2537",
    x1: 180.997,
    y1: 162.754,
    x2: 182.776,
    y2: 162.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_467_2537",
    x1: 180.957,
    y1: 162.74,
    x2: 182.736,
    y2: 162.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_467_2537",
    x1: 180.917,
    y1: 162.725,
    x2: 182.696,
    y2: 162.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_467_2537",
    x1: 180.877,
    y1: 162.71,
    x2: 182.656,
    y2: 162.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_467_2537",
    x1: 180.837,
    y1: 162.696,
    x2: 182.617,
    y2: 162.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_467_2537",
    x1: 180.797,
    y1: 162.682,
    x2: 182.577,
    y2: 162.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_467_2537",
    x1: 180.758,
    y1: 162.667,
    x2: 182.537,
    y2: 162.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_467_2537",
    x1: 180.718,
    y1: 162.652,
    x2: 182.497,
    y2: 162.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_467_2537",
    x1: 180.678,
    y1: 162.638,
    x2: 182.457,
    y2: 162.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_467_2537",
    x1: 180.638,
    y1: 162.623,
    x2: 182.417,
    y2: 162.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_467_2537",
    x1: 180.598,
    y1: 162.609,
    x2: 182.377,
    y2: 162.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_467_2537",
    x1: 180.558,
    y1: 162.594,
    x2: 182.338,
    y2: 162.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_467_2537",
    x1: 180.518,
    y1: 162.58,
    x2: 182.298,
    y2: 162.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_467_2537",
    x1: 180.479,
    y1: 162.565,
    x2: 182.258,
    y2: 162.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_467_2537",
    x1: 180.439,
    y1: 162.551,
    x2: 182.218,
    y2: 162.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_467_2537",
    x1: 180.399,
    y1: 162.536,
    x2: 182.178,
    y2: 162.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_467_2537",
    x1: 180.359,
    y1: 162.521,
    x2: 182.138,
    y2: 162.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_467_2537",
    x1: 180.319,
    y1: 162.507,
    x2: 182.098,
    y2: 162.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_467_2537",
    x1: 180.279,
    y1: 162.493,
    x2: 182.058,
    y2: 162.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_467_2537",
    x1: 180.239,
    y1: 162.478,
    x2: 182.019,
    y2: 162.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_467_2537",
    x1: 180.199,
    y1: 162.464,
    x2: 181.979,
    y2: 162.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_467_2537",
    x1: 180.159,
    y1: 162.449,
    x2: 181.939,
    y2: 162.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_467_2537",
    x1: 180.12,
    y1: 162.435,
    x2: 181.899,
    y2: 162.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_467_2537",
    x1: 180.08,
    y1: 162.42,
    x2: 181.859,
    y2: 162.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_467_2537",
    x1: 180.04,
    y1: 162.406,
    x2: 181.819,
    y2: 162.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_467_2537",
    x1: 180,
    y1: 162.391,
    x2: 181.779,
    y2: 162.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_467_2537",
    x1: 179.96,
    y1: 162.376,
    x2: 181.74,
    y2: 162.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_467_2537",
    x1: 179.92,
    y1: 162.362,
    x2: 181.7,
    y2: 162.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_467_2537",
    x1: 179.88,
    y1: 162.347,
    x2: 181.66,
    y2: 162.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_467_2537",
    x1: 179.841,
    y1: 162.333,
    x2: 181.62,
    y2: 162.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_467_2537",
    x1: 179.801,
    y1: 162.318,
    x2: 181.58,
    y2: 162.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_467_2537",
    x1: 179.761,
    y1: 162.304,
    x2: 181.54,
    y2: 162.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_467_2537",
    x1: 179.721,
    y1: 162.289,
    x2: 181.5,
    y2: 162.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_467_2537",
    x1: 179.681,
    y1: 162.275,
    x2: 181.461,
    y2: 162.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_467_2537",
    x1: 179.641,
    y1: 162.26,
    x2: 181.421,
    y2: 162.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_467_2537",
    x1: 179.601,
    y1: 162.246,
    x2: 181.381,
    y2: 162.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_467_2537",
    x1: 179.561,
    y1: 162.231,
    x2: 181.341,
    y2: 162.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_467_2537",
    x1: 179.522,
    y1: 162.217,
    x2: 181.301,
    y2: 162.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_467_2537",
    x1: 179.482,
    y1: 162.202,
    x2: 181.261,
    y2: 162.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_467_2537",
    x1: 179.442,
    y1: 162.188,
    x2: 181.221,
    y2: 162.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_467_2537",
    x1: 179.402,
    y1: 162.173,
    x2: 181.182,
    y2: 162.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_467_2537",
    x1: 179.362,
    y1: 162.159,
    x2: 181.142,
    y2: 162.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_467_2537",
    x1: 179.322,
    y1: 162.144,
    x2: 181.102,
    y2: 162.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_467_2537",
    x1: 179.282,
    y1: 162.13,
    x2: 181.062,
    y2: 162.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_467_2537",
    x1: 179.243,
    y1: 162.115,
    x2: 181.022,
    y2: 162.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_467_2537",
    x1: 179.203,
    y1: 162.1,
    x2: 180.982,
    y2: 162.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_467_2537",
    x1: 179.163,
    y1: 162.086,
    x2: 180.942,
    y2: 162.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_467_2537",
    x1: 179.123,
    y1: 162.071,
    x2: 180.902,
    y2: 162.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_467_2537",
    x1: 179.083,
    y1: 162.057,
    x2: 180.863,
    y2: 162.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_467_2537",
    x1: 179.043,
    y1: 162.042,
    x2: 180.823,
    y2: 162.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_467_2537",
    x1: 179.003,
    y1: 162.028,
    x2: 180.783,
    y2: 162.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_467_2537",
    x1: 178.963,
    y1: 162.013,
    x2: 180.743,
    y2: 162.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_467_2537",
    x1: 178.924,
    y1: 161.999,
    x2: 180.703,
    y2: 161.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_467_2537",
    x1: 178.884,
    y1: 161.984,
    x2: 180.663,
    y2: 161.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_467_2537",
    x1: 178.844,
    y1: 161.97,
    x2: 180.623,
    y2: 161.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_467_2537",
    x1: 178.804,
    y1: 161.955,
    x2: 180.584,
    y2: 161.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_467_2537",
    x1: 178.764,
    y1: 161.941,
    x2: 180.544,
    y2: 161.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_467_2537",
    x1: 178.724,
    y1: 161.926,
    x2: 180.504,
    y2: 161.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_467_2537",
    x1: 178.684,
    y1: 161.912,
    x2: 180.464,
    y2: 161.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_467_2537",
    x1: 178.645,
    y1: 161.897,
    x2: 180.424,
    y2: 161.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_467_2537",
    x1: 178.605,
    y1: 161.883,
    x2: 180.384,
    y2: 161.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_467_2537",
    x1: 178.565,
    y1: 161.868,
    x2: 180.344,
    y2: 161.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_467_2537",
    x1: 178.525,
    y1: 161.853,
    x2: 180.305,
    y2: 161.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_467_2537",
    x1: 178.485,
    y1: 161.839,
    x2: 180.265,
    y2: 161.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_467_2537",
    x1: 178.445,
    y1: 161.825,
    x2: 180.225,
    y2: 161.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_467_2537",
    x1: 178.405,
    y1: 161.81,
    x2: 180.185,
    y2: 161.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_467_2537",
    x1: 178.366,
    y1: 161.795,
    x2: 180.145,
    y2: 161.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_467_2537",
    x1: 178.326,
    y1: 161.782,
    x2: 180.105,
    y2: 161.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_467_2537",
    x1: 178.286,
    y1: 161.767,
    x2: 180.065,
    y2: 161.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_467_2537",
    x1: 178.246,
    y1: 161.753,
    x2: 180.025,
    y2: 161.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_467_2537",
    x1: 178.206,
    y1: 161.738,
    x2: 179.986,
    y2: 161.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_467_2537",
    x1: 178.166,
    y1: 161.724,
    x2: 179.946,
    y2: 161.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_467_2537",
    x1: 178.126,
    y1: 161.709,
    x2: 179.906,
    y2: 161.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_467_2537",
    x1: 178.087,
    y1: 161.695,
    x2: 179.866,
    y2: 161.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnim2);
export default __webpack_public_path__ + "static/media/anim2.a5754dc5c789041bae2e8d0f7d610442.svg";
export { ForwardRef as ReactComponent };